import { map, Observable, retry, tap } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { Endpoint } from "@pcp/http";

@Injectable()
export class ChatApiService {

    private readonly http = inject(Endpoint);

    private readonly chatEndpoint = "https://pcp-communication-services.communication.azure.com";
    private readonly chatApiUrl = `/api/live-lesson/chat`;
}
